import { DateInput } from "@msuite/ui/date-input";
import { Divider } from "@msuite/ui/divider";
import { NumberInput, Select, TextInput } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import { WeekdayPicker } from "@msuite/ui/weekday-picker";
import {
	getVacationDaysAccrualTypeTranslationKey,
	vacationDaysAccrualTypes,
} from "@msuite/utils/absences";
import { getRegionTranslationKey, REGIONS } from "@msuite/utils/misc";
import type { EmploymentFormSchema } from "@msuite/utils/schemas";
import { Fragment } from "react";
import { useFormContext } from "react-hook-form";

export function EmploymentForm() {
	/** Context */
	const methods = useFormContext<EmploymentFormSchema>();

	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<Fragment>
			<Select
				control={methods.control}
				name="region"
				label={t("misc.regions.region")}
				isRequired
				isNullable={false}
				options={REGIONS.map((region) => ({
					label: t(getRegionTranslationKey(region)),
					value: region,
					item: { region },
				}))}
			/>
			<TextInput
				isRequired
				label={t("personnel.employment.job_title")}
				control={methods.control}
				name="jobTitle"
				placeholder={t("placeholders.employment.job_title")}
			/>
			<div className="grid grid-cols-2 gap-4">
				<DateInput
					isRequired
					control={methods.control}
					name="validFrom"
					label={t("personnel.employment.valid_from")}
				/>
				<DateInput
					isRequired={false}
					control={methods.control}
					name="validTo"
					label={t("personnel.employment.valid_to")}
					isNullable
				/>
			</div>
			<Divider variant="modal" />
			<NumberInput
				label={t("absences.vacation_days")}
				isRequired
				control={methods.control}
				name="vacationDays"
				min={0}
				max={365}
			/>
			<Select
				isRequired
				isNullable={false}
				label={t("absences.accrual_type.accrual_type")}
				control={methods.control}
				name="vacationDaysAccrualType"
				options={vacationDaysAccrualTypes.map((accrualType) => ({
					label: t(getVacationDaysAccrualTypeTranslationKey(accrualType)),
					value: accrualType,
					item: { accrualType },
				}))}
			/>
			<Divider variant="modal" />
			<NumberInput
				label={t("personnel.employment.hours_per_week")}
				isRequired
				control={methods.control}
				name="hoursPerWeek"
				min={0}
				max={40}
			/>
			<WeekdayPicker
				control={methods.control}
				name="workdays"
			/>
		</Fragment>
	);
}
